import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './MyPortfolioTableProvider';
import { ILogo } from '@widgets/AccountLevelPositionsTable/lib/PositionsTableProvider/PositionsTableContext';

type DateRange = [string | null, string | null];

export interface IMyPortfolioTableContext {
    dateRange: DateRange;
    AssignPositionBody: any[];
    arrayWithLogos: ILogo[];
    portfolioLoading: boolean;
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: ITransactionDesc | null;
    setAccountId: (value: any) => void;
}

export const MyPortfolioTableContext = createContext<IMyPortfolioTableContext>({
    dateRange: [null, null],
    AssignPositionBody: [],
    paginationOptions: null,
    portfolioLoading: false,
    arrayWithLogos: [],
    sortFieldName: '',
    desc: null,
    setAccountId: emptyFunc,
});
